//STICKY TALOKIRJA-PAINIKE
// Näytetään vasta kun hero on vieritetty pois näkyvistä, jottei painike
// kilpaile heron oman CTA:n kanssa heti sivun latauduttua.
//
// Omassa kuuntelijassaan tarkoituksella: muualla sivulla tapahtuva
// JS-virhe ei saa estää tätä toimimasta.
( function () {
	function initTalokirjaTab() {
		// Sivun reunapainike (desktop) ja alapalkki (mobiili) paljastetaan
		// samalla hetkellä — kummallakin on oma piilotussuuntansa CSS:ssä.
		var targets = document.querySelectorAll( '.talokirja, [data-mobile-cta]' );
		if ( ! targets.length ) {
			return;
		}

		var hero = document.getElementById( 'hero' );

		// Kaikilla sivupohjilla ei ole heroa — silloin ei ole mitään mitä
		// vierittää ohi, joten painikkeet jätetään näkyviin.
		if ( ! hero || ! ( 'IntersectionObserver' in window ) ) {
			return;
		}

		function setClass( name, add ) {
			Array.prototype.forEach.call( targets, function ( el ) {
				el.classList[ add ? 'add' : 'remove' ]( name );
			} );
		}

		setClass( 'is-hidden', true );

		// Kaksi framea, jotta piilotus ehtii voimaan ennen kuin siirtymä
		// otetaan käyttöön — muuten painike vilahtaisi näkyvissä latauksessa.
		window.requestAnimationFrame( function () {
			window.requestAnimationFrame( function () {
				setClass( 'is-ready', true );
			} );
		} );

		var observer = new IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( entry ) {
					if ( entry.isIntersecting ) {
						return;
					}
					// Näytetään kerran ja jätetään näkyviin: edestakaisin
					// vilkkuva CTA näyttää rikkinäiseltä, eikä konversio-
					// polkua kannata ottaa pois kun se on kerran annettu.
					setClass( 'is-hidden', false );
					observer.disconnect();
				} );
			},
			{ threshold: 0 }
		);

		observer.observe( hero );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', initTalokirjaTab );
	} else {
		initTalokirjaTab();
	}
}() );

//STICKY NAV
// Yksi kuuntelija hoitaa molemmat asiat, jotka ennen olivat erikseen ja
// kiistelivät samasta .snap-luokasta:
//   - piilotus/näyttö vierityssuunnan mukaan (inline top)
//   - tiivistetty tyyli .snap kun on vieritetty tarpeeksi alas
( function () {
	var nav = document.getElementById( 'main-nav' );
	if ( ! nav ) {
		return;
	}

	var SNAP_AT  = 50; // px, jonka jälkeen navi menee tiiviiseen tyyliin
	var MIN_MOVE = 5;  // iOS:n vauhtivieritys tuottaa paljon mikroliikettä

	var lastY   = Math.max( 0, window.pageYOffset );
	var ticking = false;

	function update() {
		ticking = false;

		// iOS venyttää vieritystä sivun reunojen yli, jolloin pageYOffset
		// menee negatiiviseksi. Ilman rajausta nollaan paluu venytyksestä
		// näyttää alaspäin vieritykseltä ja navi piiloutuu juuri silloin
		// kun ollaan sivun yläreunassa.
		var y     = Math.max( 0, window.pageYOffset );
		var delta = y - lastY;

		nav.classList.toggle( 'snap', y > SNAP_AT );

		// Yläreunassa navi on aina näkyvissä, vierityssuunnasta riippumatta.
		if ( y <= 0 ) {
			nav.style.top = '0';
			lastY = y;
			return;
		}

		// Liian pieni liike: ei muuteta tilaa, eikä päivitetä lastY:tä,
		// jotta pienet liikkeet kertyvät kynnyksen yli.
		if ( Math.abs( delta ) < MIN_MOVE ) {
			return;
		}

		if ( delta > 0 && y > nav.offsetHeight ) {
			// Korkeus luetaan elementiltä, koska .snap muuttaa sitä.
			nav.style.top = '-' + nav.offsetHeight + 'px';
		} else if ( delta < 0 ) {
			nav.style.top = '0';
		}

		lastY = y;
	}

	window.addEventListener( 'scroll', function () {
		if ( ! ticking ) {
			ticking = true;
			window.requestAnimationFrame( update );
		}
	}, { passive: true } );

	update();
}() );

//LIGHTBOX
// Yleiskäyttöinen kuvasuurennus. Lisää linkkiin luokka js-lightbox:
//
//   <a href="iso.jpg" class="js-lightbox"><img src="pieni.jpg" alt="..."></a>
//
// Yksittäinen kuva toimii sellaisenaan. Useamman kuvan selaaminen keskenään
// onnistuu antamalla niille sama data-lightbox-group="nimi".
//
// Linkki toimii myös ilman JS:ää, jolloin se avaa kuvan normaalisti.
( function () {
  function init() {
    const modalEl = document.getElementById("siteLightbox");
    const Modal = window.understrap && window.understrap.Modal;

    if (!modalEl || !Modal) {
      return; // Ilman modaalia linkit toimivat tavallisina linkkeinä.
    }

    const imgEl = modalEl.querySelector(".lightbox__img");
    const counterEl = modalEl.querySelector(".lightbox__counter");
    const prevEl = modalEl.querySelector(".lightbox__prev");
    const nextEl = modalEl.querySelector(".lightbox__next");
    const modal = new Modal(modalEl);

    let slides = [];
    let index = 0;

    function sourceOf(el) {
      const img = el.querySelector("img");
      return (
        el.getAttribute("data-full") ||
        (el.tagName === "A" ? el.getAttribute("href") : "") ||
        (img ? img.getAttribute("src") : "")
      );
    }

    function altOf(el) {
      const img = el.querySelector("img");
      return el.getAttribute("data-alt") || (img ? img.alt : "");
    }

    // Ungrouped triggers stand alone; grouped ones page through together.
    function collect(trigger) {
      const group = trigger.getAttribute("data-lightbox-group");
      const els = group
        ? Array.prototype.slice.call(
            document.querySelectorAll(
              '.js-lightbox[data-lightbox-group="' + group + '"]'
            )
          )
        : [trigger];

      // The same image can appear more than once in a group (carousel
      // clones), so collapse duplicates by source.
      const seen = {};
      const out = [];
      els.forEach(function (el) {
        const src = sourceOf(el);
        if (!src || seen[src]) {
          return;
        }
        seen[src] = true;
        out.push({ src: src, alt: altOf(el) });
      });
      return out;
    }

    function show(i) {
      if (!slides.length) {
        return;
      }
      index = (i + slides.length) % slides.length;
      imgEl.src = slides[index].src;
      imgEl.alt = slides[index].alt;

      const many = slides.length > 1;
      modalEl.classList.toggle("is-single", !many);
      if (counterEl) {
        counterEl.textContent = many ? index + 1 + " / " + slides.length : "";
      }
    }

    document.addEventListener("click", function (e) {
      const trigger = e.target.closest ? e.target.closest(".js-lightbox") : null;
      if (!trigger) {
        return;
      }

      const src = sourceOf(trigger);
      if (!src) {
        return; // Nothing to show — leave the link alone.
      }

      e.preventDefault();
      slides = collect(trigger);

      let start = 0;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].src === src) {
          start = i;
          break;
        }
      }

      show(start);
      modal.show();
    });

    if (prevEl) {
      prevEl.addEventListener("click", () => show(index - 1));
    }
    if (nextEl) {
      nextEl.addEventListener("click", () => show(index + 1));
    }

    // Escape, focus trapping and focus restore come from Modal; only
    // paging between images is ours.
    modalEl.addEventListener("keydown", function (e) {
      if (slides.length < 2) {
        return;
      }
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        show(index - 1);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        show(index + 1);
      }
    });
  }

  if ("loading" === document.readyState) {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

//CAROUSEL
document.addEventListener("DOMContentLoaded", function () {
  // DOM elements
  const carousel = document.getElementById("multiCarousel");
  const carouselInner = document.getElementById("carouselInner");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");

  // The carousel only exists on single posts. Without this guard everything
  // below throws on every other page — and takes the rest of this handler
  // down with it.
  if (!carousel || !carouselInner || !prevBtn || !nextBtn) {
    return;
  }

  // Counted from the DOM rather than hardcoded: the gallery is an ACF
  // field, so the number of images is whatever the editor uploaded. A fixed
  // count puts the infinite-loop wrap points in the wrong place for every
  // gallery that isn't exactly that size.
  const totalItems = carouselInner.querySelectorAll(
    ".multi-carousel-item:not(.clone)"
  ).length;

  if (!totalItems) {
    return;
  }

  // An auto-rotating carousel is a known problem for vestibular disorders,
  // so honour the OS setting rather than moving regardless.
  const reduceMotion = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : { matches: false };

  // Configuration - measured from the rendered layout
  let itemsPerSlide = 1;
  let slideBy = 1; // How many items to advance/retreat per click

  // The stylesheet owns how many items fit across; the transform maths
  // assumes each item is 100/itemsPerSlide wide. Rather than restate the
  // breakpoint ladder here — where the two can drift apart, which is
  // exactly how the track ended up stepping 25% over 20%-wide items — read
  // the real widths back off the DOM.
  function updateConfig() {
    const sample = carouselInner.querySelector(".multi-carousel-item, .clone");
    const trackWidth = carouselInner.getBoundingClientRect().width;
    const itemWidth = sample ? sample.getBoundingClientRect().width : 0;

    itemsPerSlide =
      itemWidth > 0 && trackWidth > 0
        ? Math.max(1, Math.round(trackWidth / itemWidth))
        : 1;

    slideBy = 1;
  }

  // Dynamically add clone elements
  function initializeClones() {
    // Scoped to the track so this always agrees with the totalItems count
    // above.
    const originalItems = Array.from(
      carouselInner.querySelectorAll(".multi-carousel-item:not(.clone)")
    );

    // Clear existing clones
    carouselInner.querySelectorAll(".clone").forEach((clone) => clone.remove());

    // Always exactly itemsPerSlide clones per side, cycling through the
    // originals when the gallery is shorter than one screenful. Slicing
    // instead would yield too few and shift the first real item out of
    // position.
    const n = originalItems.length;
    const buildRun = (count, leading) => {
      const run = [];
      for (let i = 0; i < count; i++) {
        const index = leading
          ? (((n - count + i) % n) + n) % n
          : i % n;
        const clone = originalItems[index].cloneNode(true);
        clone.classList.add("clone");
        // Duplicate content: present for the visual loop only.
        clone.setAttribute("aria-hidden", "true");
        clone
          .querySelectorAll("button, a, [tabindex]")
          .forEach((el) => el.setAttribute("tabindex", "-1"));
        run.push(clone);
      }
      return run;
    };

    carouselInner.prepend(...buildRun(itemsPerSlide, true));
    buildRun(itemsPerSlide, false).forEach((clone) => carouselInner.append(clone));
  }

  // Initial setup
  updateConfig();
  initializeClones();

  // Start with the first real set of images
  let currentIndex = 0; // Index of current visible center image (0 to totalItems-1)
  let position = itemsPerSlide; // Real position considering clones
  let isAnimating = false;

  // Returns whether a transition will actually run, so callers know
  // whether a transitionend is coming.
  function updateCarouselPosition(animate = true) {
    const willAnimate = animate && !reduceMotion.matches;

    carouselInner.style.transition = willAnimate
      ? "transform 0.5s ease"
      : "none";

    const translateX = (position * -100) / itemsPerSlide;
    carouselInner.style.transform = `translateX(${translateX}%)`;

    return willAnimate;
  }

  // Everything that has to happen once a move has finished. Driven by
  // transitionend normally, but called directly when no transition will
  // run (reduced motion) — otherwise isAnimating is never cleared and the
  // carousel locks after a single step.
  function settle() {
    isAnimating = false;

    // Handle infinite loop logic
    if (position >= totalItems + itemsPerSlide) {
      position = itemsPerSlide + (position - (totalItems + itemsPerSlide));
      updateCarouselPosition(false);
    } else if (position < itemsPerSlide) {
      position = totalItems + position;
      updateCarouselPosition(false);
    }

    currentIndex = (position - itemsPerSlide) % totalItems;
  }

  // Initialize position
  updateCarouselPosition(false);

  // Handle transition end
  carouselInner.addEventListener("transitionend", function (e) {
    if (e.target !== carouselInner || e.propertyName !== "transform") {
      return;
    }
    settle();
  });

  // Navigation functions
  function next() {
    if (isAnimating) return;
    isAnimating = true;
    position += slideBy;
    if (!updateCarouselPosition()) {
      settle();
    }
  }

  function prev() {
    if (isAnimating) return;
    isAnimating = true;
    position -= slideBy;
    if (!updateCarouselPosition()) {
      settle();
    }
  }

  // Event listeners for buttons
  nextBtn.addEventListener("click", next);
  prevBtn.addEventListener("click", prev);

  // Mouse drag functionality
  let isDragging = false;
  let startX = 0;
  let startPosition = 0;
  let dragMoved = false;

  // Prevent image drag
  const carouselImages = document.querySelectorAll("#carouselInner img");
  carouselImages.forEach((img) => {
    img.addEventListener("dragstart", (e) => {
      e.preventDefault();
    });
  });

  carousel.addEventListener("mousedown", startDrag);
  carousel.addEventListener("touchstart", startDrag, { passive: true });

  carousel.addEventListener("mousemove", drag);
  carousel.addEventListener("touchmove", drag, { passive: true });

  carousel.addEventListener("mouseup", endDrag);
  carousel.addEventListener("touchend", endDrag);
  carousel.addEventListener("mouseleave", endDrag);

  function startDrag(e) {
    if (e.type.includes("mouse") && e.target.tagName === "IMG") {
      e.preventDefault();
    }

    if (isAnimating) return;

    isDragging = true;
    dragMoved = false;
    startX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
    startPosition = position;
    carousel.classList.add("dragging");
    carouselInner.style.transition = "none";
    document.body.style.cursor = "grabbing";
    document.body.style.userSelect = "none";
    registerUserActivity();
  }

  function drag(e) {
    if (!isDragging) return;

    const x = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
    if (Math.abs(x - startX) > 8) {
      dragMoved = true;
    }
    const walk = ((x - startX) / carousel.offsetWidth) * itemsPerSlide;
    const newPosition = startPosition - walk;
    const translateX = (newPosition * -100) / itemsPerSlide;
    carouselInner.style.transform = `translateX(${translateX}%)`;
  }

  function endDrag(e) {
    if (!isDragging) return;

    isDragging = false;
    carousel.classList.remove("dragging");
    document.body.style.cursor = "";
    document.body.style.userSelect = "";
    carouselInner.style.transition = "transform 0.5s ease";

    const x = e.type?.includes("mouse")
      ? e.clientX
      : e.changedTouches
      ? e.changedTouches[0].clientX
      : startX;
    const walk = ((x - startX) / carousel.offsetWidth) * itemsPerSlide;

    if (walk > 0.2) {
      prev();
    } else if (walk < -0.2) {
      next();
    } else {
      updateCarouselPosition();
    }

    registerUserActivity();
  }

  // Keyboard navigation, scoped to the carousel. Listening on document
  // meant arrow keys stopped scrolling the article whenever the gallery
  // happened to be on screen.
  carousel.addEventListener("keydown", function (e) {
    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault();
        prev();
        registerUserActivity();
        break;
      case "ArrowRight":
        e.preventDefault();
        next();
        registerUserActivity();
        break;
    }
  });

  // Auto-advance system
  let autoAdvanceInterval;
  let userActivityTimeout;

  function startAutoAdvance() {
    clearInterval(autoAdvanceInterval);
    if (reduceMotion.matches || document.hidden) {
      return;
    }
    autoAdvanceInterval = setInterval(next, 5000);
  }

  function resetAutoAdvanceTimer() {
    clearTimeout(userActivityTimeout);
    clearInterval(autoAdvanceInterval);
    userActivityTimeout = setTimeout(startAutoAdvance, 10000);
  }

  function registerUserActivity() {
    resetAutoAdvanceTimer();
  }

  // setInterval keeps firing in a background tab, so returning to it plays
  // a burst of queued transitions.
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      clearInterval(autoAdvanceInterval);
      clearTimeout(userActivityTimeout);
    } else {
      startAutoAdvance();
    }
  });

  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener("change", function () {
      if (reduceMotion.matches) {
        clearInterval(autoAdvanceInterval);
      } else {
        startAutoAdvance();
      }
    });
  }

  startAutoAdvance();

  carousel.addEventListener("mouseenter", () => {
    clearInterval(autoAdvanceInterval);
  });

  carousel.addEventListener("mouseleave", () => {
    resetAutoAdvanceTimer();
  });

  carousel.addEventListener("click", registerUserActivity);
  carousel.addEventListener("wheel", registerUserActivity);

  // Handle window resize, coalesced to one run per frame — the handler
  // reads layout, which is expensive to do on every resize event.
  let resizeTicking = false;
  window.addEventListener("resize", function () {
    if (resizeTicking) {
      return;
    }
    resizeTicking = true;
    window.requestAnimationFrame(onResize);
  });

  function onResize() {
    resizeTicking = false;
    const previousPerSlide = itemsPerSlide;
    updateConfig();

    // Rebuild only when the number across actually changed — with a
    // gradual ladder that now happens at several widths, not just one.
    if (previousPerSlide !== itemsPerSlide) {
      initializeClones();
      position = itemsPerSlide; // Reset position
      updateCarouselPosition(false);
    }
  }

  // Pause the carousel while the lightbox is open, and don't let a swipe
  // that ends on an image count as a click on it.
  carousel.addEventListener("click", function (e) {
    if (dragMoved && e.target.closest(".js-lightbox")) {
      dragMoved = false;
      e.preventDefault();
      // Stops the document-level lightbox handler from seeing this click.
      e.stopPropagation();
    }
  });

  const siteLightbox = document.getElementById("siteLightbox");
  if (siteLightbox) {
    siteLightbox.addEventListener("show.bs.modal", () =>
      clearInterval(autoAdvanceInterval)
    );
    siteLightbox.addEventListener("hidden.bs.modal", resetAutoAdvanceTimer);
  }
});

// DESKTOP DROPDOWN: hover avaa alavalikon,
// klikkaus seuraa varsinaista linkkiä.
// Mobiilissa Bootstrapin dropdown-toiminto säilyy.

(function () {
    const breakpoint = window.matchMedia('(min-width: 992px)');

    function updateDropdownBehaviour() {
        const dropdownLinks = document.querySelectorAll(
            '#main-menu > li.menu-item-has-children > a[data-bs-toggle="dropdown"], ' +
            '#main-menu > li.menu-item-has-children > a[data-dropdown-toggle-disabled]'
        );

        dropdownLinks.forEach(function (link) {

            if (breakpoint.matches) {

                // Desktop:
                // poistetaan Bootstrapin click-dropdown käytöstä.
                if (link.getAttribute('data-bs-toggle') === 'dropdown') {
                    link.setAttribute('data-dropdown-toggle-disabled', 'true');
                    link.removeAttribute('data-bs-toggle');
                }

                // Bootstrapilta mahdollisesti jäänyt tila pois.
                link.classList.remove('show');
                link.setAttribute('aria-expanded', 'false');

                const menu = link.parentElement.querySelector(':scope > .dropdown-menu');

                if (menu) {
                    menu.classList.remove('show');
                }

            } else {

                // Mobiili:
                // palautetaan Bootstrapin normaali dropdown.
                if (link.hasAttribute('data-dropdown-toggle-disabled')) {
                    link.setAttribute('data-bs-toggle', 'dropdown');
                    link.removeAttribute('data-dropdown-toggle-disabled');
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateDropdownBehaviour);
    } else {
        updateDropdownBehaviour();
    }

    if (breakpoint.addEventListener) {
        breakpoint.addEventListener('change', updateDropdownBehaviour);
    } else {
        breakpoint.addListener(updateDropdownBehaviour);
    }
})();